import Request from '@/utils/request'

// 首充 后 再充
export function afterFirstRechargeApi() {
  return Request({
    url: '/api/v2/app/shop/activity/11/cfg',
    method: 'get',
    envelope: false,
  })
}
